/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

/**
 * Clerk Helpers
 */

/**
 * Converts htmlString into nodeElement
 * @param {string} htmlString
 * @returns
 */
const createElementFromHTML = (htmlString) => {
  var div = document.createElement('div');
  div.innerHTML = htmlString.trim();
  return div.firstElementChild;
};

/**
 * Add event deligation on swatches
 * * @param {HTMLElement} productCard
 * @param {String} swatchListClass
 */
const initProductCardSwatches = (
  productCard,
  swatchListClass = '.color-swatch-list'
) => {
  const swatchList = productCard.querySelector(swatchListClass);

  if (!swatchList) return;
  const productLinksArr = productCard.querySelectorAll('a');
  const swatchListContainer = productCard.querySelector(
    '.product-item__swatch-list'
  );
  const swatches = swatchList.querySelectorAll('.color-swatch');
  const swatchListContainerWidth = swatchListContainer.offsetWidth;

  /**
   * Add view more class when the swatches goes out of the container
   */
  for (let index = 0; index < swatches.length; index++) {
    const swatch = swatches[index];
    if (
      swatch.offsetLeft + swatch.offsetWidth >
      swatchListContainerWidth - swatch.offsetWidth
    ) {
      swatch.classList.add('color-swatch--view-more');
      break;
    }
  }

  /**
   * Add click event to the swatch, to change the url
   */
  swatchList.addEventListener('click', (event) => {
    const target = event.target;

    if (target.tagName !== 'INPUT') return;
    if (!target.hasAttribute('data-variant-url')) return;

    const newVariantUrl = target.getAttribute('data-variant-url');
    productLinksArr.forEach((productLink) => {
      productLink.setAttribute('href', newVariantUrl);
    });
  });
};

/**
 * End - Clerk Helpers
 */

const initCardOffset = () => {
  const cardOffsets = document.querySelectorAll('[data-stick-card-offset]');
  const mainHeader = document.getElementById('shopify-section-header');
  const additionalOffset = 20;

  if (!mainHeader) return;
  cardOffsets.forEach((cardOffset) => {
    cardOffset.style.top = `${additionalOffset + mainHeader.offsetHeight}px`;
    cardOffset.style.maxHeight = `calc(100vh - ${
      additionalOffset * 2 + mainHeader.offsetHeight
    }px)`;
  });
};

const ready = () => {
  initCardOffset();
};

if (
  document.readyState === 'complete' ||
  document.readyState === 'interactive'
) {
  ready();
} else {
  document.addEventListener('DOMContentLoaded', () => ready(), {
    once: true,
  });
}

class stickyCartButton {
  constructor(main) {
    this.dom = {
      main: main,
      staticButton: main.parentElement.querySelector(
        '.product-form__payment-container--mobile__static'
      ),
    };
    if (!this.dom.staticButton) return;
    this.Init();
  }

  Init() {
    this.InitIntersectionObserver();
  }


  InitIntersectionObserver() {
    let options = {
      rootMargin: '50px 100px',
      threshold: 0,
    };

    // Register IntersectionObserver
    const io = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.intersectionRatio > 0) {
          // Remove 'active' class otherwise
          this.dom.main.classList.remove('active');
        } else {
          // Add 'active' class if observation target is inside viewport
          this.dom.main.classList.add('active');
        }
      });
    }, options);
    // Declares what to observe, and observes its properties.
    io.observe(this.dom.staticButton);
  }
}

const stickyAddToCartButtons = document.querySelectorAll(
  '.product-form__payment-container--mobile__sticky'
);
stickyAddToCartButtons.forEach((stickyAddToCartButton) => {
  new stickyCartButton(stickyAddToCartButton);
});

